<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="employee_position"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="positionForm"
          :redirect-detail="false"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Jabatan Karyawan"
          addButton="Tambah Jabatan"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>

        <b-modal
          ref="myModalRef"
          id="addModals"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="lg"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center" v-if="!isEdit">Tambah Jabatan Baru</h3>
            <h3 class="text-center" v-else-if="isEdit">Ubah Jabatan</h3>
          </div>

          <b-form id="positionForm" validated novalidate>
            <div v-if="!loadingSubmitModal">
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="name" label="Nama Jabatan">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="$v.positionForm.name.$model"
                      :state="!$v.positionForm.name.$invalid"
                      required
                      placeholder="Nama Jabatan"
                    ></b-form-input>
                    <b-form-invalid-feedback>Nama jabatan harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="division_id" label="Divisi">
                    <model-select
                      id="division_id"
                      :options="listDivision"
                      v-model="$v.positionForm.division_id.$model"
                      :isError="$v.positionForm.division_id.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="positionForm.division_id === null"
                      class="invalid-feedback-custom"
                    >Nama divisi harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="level" label="Level Akses">
                    <model-select
                      id="level"
                      :options="listLevel"
                      v-model="$v.positionForm.level.$model"
                      :isError="$v.positionForm.level.$invalid"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="positionForm.level === null"
                      class="invalid-feedback-custom"
                    >Level akses harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group label-for="description" label="Deskripsi">
                    <b-form-textarea
                      id="description"
                      :rows="3"
                      :max-rows="6"
                      v-model="$v.positionForm.description.$model"
                      :state="!$v.positionForm.description.$invalid"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading></loading>
            </div>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!loadingSubmitModal">
              <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="saveProcess"
                :disabled="$v.positionForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "employee_position",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      employee_position: [],
      listLevel: [
          {value: '1', text: 'Level Akses Manager'}, 
          {value: '2', text: 'Level Akses SPV'},
          {value: '3', text: 'Level Akses Staff'}
      ],
      listDivision: [],
      loading: true,
      loadingSubmitModal: false,
      fields: [
        {
          key: "name",
          label: "Jabatan",
          class: "width-250",
          sortable: true
        },
        { key: "division_name", label: "Nama Divisi" },
        { key: "level_access", label: "Level Akses" },
        { key: "description", label: "Deskripsi" },
        { key: "action", class: "width-50 text-center" }
      ],
      positionForm: masterInterfaces.position,
      isEdit: false
    };
  },
  validations: {
    positionForm: {
      name: { required },
      division_id: { required },
      level: { required },
      description: {}
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.getPosition();
      this.getDropdown();
    },
    getPosition: function() {
      this.axios
        .get("web/master/employee/position/all/")
        .then(response => {
          this.employee_position = response.data.data;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/employee/")
        .then(response => {
          this.listDivision = response.data.employee_division;
        })
        .catch(error => {
          this.expired(error)
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function(e) {
      this.isEdit = true;
      this.resetForm();
      this.positionForm = e;
    },
    resetForm: function() {
      for (var a in masterInterfaces.position) {
        masterInterfaces.position[a] = null;
      }
      this.positionForm = masterInterfaces.position;
    },
    cancelAdd: function() {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function(evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah posisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put("web/master/employee/position/edit/", this.positionForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Divisi Berhasil",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan posisi ini?")) {
          this.loadingSubmitModal = true;
          this.axios
            .post("web/master/employee/position/add/", this.positionForm)
            .then(response => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Posisi Berhasil",
                  message: response.data.message
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Posisi Gagal",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

  